// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"08af8280","314":"ade361ee","527":"2855bef0","918":"ac7a590f","965":"8954583f"}[chunkId] + ".chunk.js";
};